import { CapacityCalendarRowWrapper } from "../capacity-calendar";

/** Props Interface */
interface CapacityManagerSectionRowProps {
	label: string;
}

/**
 * The bar that divides the manager roster into sections — the signed-in manager above it, everyone
 * else below.
 *
 * It spans the whole board and draws no day strip, the same shape the planner view's category bar
 * takes: a separator stands for no one, so there is no capacity to show across the window.
 */
export function CapacityManagerSectionRow({ label }: CapacityManagerSectionRowProps) {
	/** Render */
	return (
		<CapacityCalendarRowWrapper variant="group">
			<div className="h-stack min-w-0 col-span-full">
				<p className="text-sm font-medium truncate">{label}</p>
			</div>
		</CapacityCalendarRowWrapper>
	);
}
